/*jshint globalstrict: false*/

import Vue from 'vue';
import OnboardingShell from '../components/home/onboarding/onboarding-shell-home';
import axios from 'axios';

Vue.component('onboarding-home', OnboardingShell);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            Vue.prototype.$thirdPartyApi = axios.create({});

            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="onboarding-home-vue"]',
    });
});
